import { z } from "zod";

const num = z.number().finite();
const int = z.number().int();
const layers = z.union([int, z.array(int).min(1)]);

const ModelSchema = z.object({
  kaq: z.union([num, z.array(num)]).optional(),
  z: z.array(num).min(2).optional(),
  npor: z.union([num, z.array(num)]).optional(),
  topboundary: z.enum(["conf"]).optional(),
  hstar: num.nullable().optional(),
});

const UflowSchema = z.object({
  slope: num.optional(),
  angle: num,
  label: z.string().optional(),
});

const ConstantSchema = z.object({
  xr: num,
  yr: num,
  hr: num,
  layer: int.optional(),
});

const RechargeSchema = z.object({
  xc: num,
  yc: num,
  R: num.positive(),
  N: num,
  layer: int.optional(),
  label: z.string().optional(),
});

const RiverSchema = z.object({
  xy: z.array(z.tuple([num, num])).min(2),
  hls: num.optional(),
  res: num.optional(),
  wh: num.optional(),
  order: int.optional(),
  layers: layers.optional(),
  dely: num.optional(),
  label: z.string().optional(),
});

const WellSchema = z.object({
  captureId: int.positive(),
  inputId: int.positive(),
  rw: num.positive().optional(),
  res: num.optional(),
  layers: layers.optional(),
  label: z.string().optional(),
});

const CaptureZoneSchema = z.object({
  nt: int.positive().optional(),
  zstart: num.nullable().optional(),
  hstepmax: num.positive().optional(),
  vstepfrac: num.positive().optional(),
  nstepmax: int.positive().optional(),
  silent: z.union([z.boolean(), z.literal(".")]).optional(),
});

export const TimflowSteadyRequestSchema = z.object({
  model: ModelSchema.optional(),
  uflow: UflowSchema.optional(),
  constants: z.array(ConstantSchema).optional(),
  recharge: z.array(RechargeSchema).optional(),
  rivers: z.array(RiverSchema).optional(),
  wells: z.array(WellSchema).min(1),
  captureZone: CaptureZoneSchema.optional(),
});

export type TimflowSteadyRequest = z.infer<typeof TimflowSteadyRequestSchema>;

export const TimflowSteadyCsvQuerySchema = z.object({
  days: num.positive(),
});

export type TimflowSteadyCsvQuery = z.infer<typeof TimflowSteadyCsvQuerySchema>;